import { forEach } from 'lodash';
import { Dispatch } from 'react';
import { PaginateList } from '../../../common/types/common-types';
import { getDayStart, getDayEnd } from 'src/app/common/utils/time-utils';
import { MdrtStoryDetail, MdrtStoryItem } from '../types/mdrt-story-types';
import { apiClient, apiErrorHandler } from 'src/app/common/network';

const ADMIN_URL = `${window.envConfig['REACT_APP_APIM_BASE_URL']}${window.envConfig['REACT_APP_APIM_MDRT']}`;

export type MdrtStoryListParams = {
  agentCode: string;
  title: string;
  page: number;
  limit: number;
};

export const create = async (data: MdrtStoryDetail, dispatch?: Dispatch<any>): Promise<MdrtStoryDetail> => {
  return apiClient
    .post<MdrtStoryDetail>(`${ADMIN_URL}/mdrt-hub/story`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const update = async (data: MdrtStoryDetail, dispatch?: Dispatch<any>): Promise<MdrtStoryDetail> => {
  return apiClient
    .put<MdrtStoryDetail>(`${ADMIN_URL}/mdrt-hub/story/${data.id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchItem = async (id: string, dispatch?: Dispatch<any>): Promise<MdrtStoryDetail> => {
  return apiClient
    .get<MdrtStoryDetail>(`${ADMIN_URL}/mdrt-hub/story/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchList = async (
  params: MdrtStoryListParams,
  dispatch?: Dispatch<any>,
): Promise<PaginateList<MdrtStoryItem>> => {
  let queryPath = `${ADMIN_URL}/mdrt-hub/story/list?`;

  forEach(params, (param, key) => {
    if (typeof param === 'object') {
      if (param) {
        if (key.includes('From')) {
          queryPath += `${key}=${getDayStart(param).toISOString()}&`;
        }
        if (key.includes('To')) {
          queryPath += `${key}=${getDayEnd(param).toISOString()}&`;
        }
      }
    } else {
      queryPath += param ? `${key}=${param}&` : '';
    }
  });

  return apiClient
    .get<PaginateList<MdrtStoryItem>>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const publish = async (id: string, dispatch?: Dispatch<any>): Promise<MdrtStoryDetail> => {
  return apiClient
    .patch<MdrtStoryDetail>(`${ADMIN_URL}/mdrt-hub/story/${id}/publish`, { id })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const unpublish = async (id: string, dispatch?: Dispatch<any>): Promise<MdrtStoryDetail> => {
  return apiClient
    .patch<MdrtStoryDetail>(`${ADMIN_URL}/mdrt-hub/story/${id}/unpublish`, { id })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const deleteItem = async (id: string, dispatch?: Dispatch<any>): Promise<any> => {
  return apiClient
    .delete(`${ADMIN_URL}/mdrt-hub/story/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const checkAgentCode = async (agentCode: string, dispatch?: Dispatch<any>): Promise<any> => {
  return apiClient
    .post(`${ADMIN_URL}/mdrt-hub/story/check-agent-code`, { agentCode })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
